import HomePage from 'components/home/HomePage';
import SettingsPage from 'components/settings/SettingsPage';
import React, { useContext, useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'store/configs/Routes';
import NotFoundPage from 'components/layout/NotFoundPage';
import SiteModule from 'store/enums/SiteModule';
import { ConfigContext } from 'components/ConfigGuard';
import { getDefaultHomeRoute } from 'util/Route';
import ViewCredentials from './credentials/ViewCredentials/ViewCredentials';
import { BadgeDetailsPage } from './credentials/BadgeDetailsPage';
import VerifyCredentials from './credentials/VerifyCredentials/VerifyCredentials';
import ViewMyCredentials from './credentials/ViewMyCredentials';
import { ReportsPage } from './reports/ReportsPage';
import PrintCredentials from './credentials/PrintCredentials';

const AppProtectedRoutes: React.FunctionComponent = () => {
  const { enabledModules = [], sidebar } = useContext(ConfigContext);

  const appRoutes: React.ReactNode[] = useMemo(() => {
    let result: React.ReactNode[] = [
      <Route key={'default'} path={'/'} element={<Navigate to={getDefaultHomeRoute(enabledModules)} />} />,
    ];

    if (enabledModules.includes(SiteModule.Home)) {
      result = [
        ...result,
        <Route key={'home'} path={routes.home} element={<HomePage />} />,
      ];
    }

    if (enabledModules.includes(SiteModule.Credentials)) {
      result = [
        ...result,
        <Route key={'myCredentials'} path={routes.myCredentials} element={<ViewMyCredentials />} />,
        <Route key={'viewCredentials'} path={routes.viewCredentials}>
          <Route index element={<ViewCredentials />} />
          <Route path=":nccerNumber" element={<ViewCredentials />} />
        </Route>,
        <Route key={'printCredentials'} path={routes.printCredentials} element={<PrintCredentials />} />,
        <Route key={'badgeDetails'} path={routes.badgeDetails}>
          <Route index element={<BadgeDetailsPage />} />
          <Route path=":nccerNumber" element={<BadgeDetailsPage />} />
        </Route>,
        <Route key={'verifyCredentials'} path={routes.verifyCredentials} element={<VerifyCredentials />} />,
      ];
    }

    // Currently, no profile module for NCCER (3/14)
    // if (enabledModules.includes(SiteModule.Profile)) {
    //   sidebar.forEach((item) => {
    //     if (item.type === SiteModule.Profile) {
    //       result = [
    //         ...result,
    //         <Route key={"profile"} path={routes.profile} exact={true}>
    //           <ProfilePage />
    //         </Route>,
    //       ];
    //     }
    //   });
    // }

    if (enabledModules.includes(SiteModule.Reports)) {
      result = [
        ...result,
        <Route key={'reports'} path={routes.reports}>
          <Route index element={<ReportsPage />} />
          <Route path=":reportCode" element={<ReportsPage />} />
        </Route>,
      ];
    }

    if (enabledModules.includes(SiteModule.Settings)) {
      result = [
        ...result,
        <Route key={'settings'} path={routes.settings} element={<SettingsPage />} />,
      ];
    }

    return [
      ...result,
      <Route key={'not-found'} path={'*'} element={<NotFoundPage />} />,
    ];
  }, [enabledModules, sidebar]);

  return <Routes>{appRoutes}</Routes>;
};
export default AppProtectedRoutes;
